import { FC } from "react"
import { Stack } from "@mui/material"
import UrlButton from "@modules/postBot/components/posts/postField/urlButtons/urlButton"
import { ReplyMarkup } from "../../interfaces"

interface IProps {
  markup: ReplyMarkup | null
}

export const UrlButtonsPreview: FC<IProps> = ({ markup }) => {
  if (!markup?.inline_keyboard.length) return null

  return (
    <Stack spacing={1} role="group" aria-label="Кнопки материала">
      {markup.inline_keyboard.map((row, rowIndex) => (
        <Stack
          direction="row"
          spacing={1}
          key={rowIndex}
          role="group"
          aria-label={`Строка ${rowIndex + 1}: ${row.map(({ text }) => text).join("; ")}`}
        >
          {row.map((button, buttonIndex) => (
            <UrlButton key={buttonIndex} data={button} nonInteractive />
          ))}
        </Stack>
      ))}
    </Stack>
  )
}
